<template>
  <a-flex gap="middle" justify="center">
    <a-tooltip :title="defaultActionTooltip">
      <a-button
        :disabled="label.label.isDefault || isLabelUpdating"
        v-if="!setDefaultIsHidden"
        @click="setAsDefault()"
        :icon="h(CheckCircleOutlined)"
        type="link"
        class="icon-button"
      />
    </a-tooltip>

    <a-tooltip
      v-if="labelTemplateStore.isAdminAccount"
      :title="'Создать общую этикетку'"
    >
      <router-link
        :to="{
          name: 'labelsEdit',
          params: { labelId: 'create' },
          query: { shareId: label.label.id, isCommon: 'true' },
        }"
      >
        <a-button
          :disabled="isLabelUpdating"
          :icon="h(ShareAltOutlined)"
          class="icon-button clone"
        />
      </router-link>
    </a-tooltip>

    <a-tooltip :title="'Редактировать этикетку'">
      <router-link
        :to="{ name: 'labelsEdit', params: { labelId: label.label.id } }"
      >
        <a-button
          :disabled="isLabelUpdating"
          :icon="h(EditOutlined)"
          class="icon-button"
        />
      </router-link>
    </a-tooltip>

    <a-tooltip :title="'Удалить этикетку'">
      <a-button
        :disabled="isLabelUpdating"
        danger
        @click="deleteLabel()"
        :icon="h(DeleteOutlined)"
        class="icon-button delete"
      />
    </a-tooltip>
  </a-flex>
</template>

<script setup lang="ts">
import {
  type LabelTemplateTableData,
  useLabelTemplateStore,
} from "@/stores/labelTemplate/labelTemplateStore";
import { computed, h } from "vue";
import {
  CheckCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  ShareAltOutlined,
} from "@ant-design/icons-vue";
import { showConfirm } from "@/tools/ConfirmationDialog";

const props = defineProps<{ label: LabelTemplateTableData }>();

const labelTemplateStore = useLabelTemplateStore();

const defaultActionTooltip = computed(() =>
  props.label.label.isDefault
    ? `Этикетка по умолчанию типа '${props.label.destinationType}'`
    : `Сделать этикеткой по умолчанию в типе '${props.label.destinationType}'`,
);

const isLabelUpdating = computed(() =>
  labelTemplateStore.processingPersonalLabels.has(props.label.label.id),
);

const setDefaultIsHidden = computed(() => {
  const allLabels = labelTemplateStore.allPersonalLabels;

  const countTheSameLabels = allLabels.filter(
    (label) => label.destinationType === props.label.label.destinationType,
  ).length;

  return countTheSameLabels <= 1;
});

const setAsDefault = () =>
  labelTemplateStore.setDefaultLabelTemplate(props.label.label.id);

const deleteLabel = () => {
  showConfirm({
    title: `Вы действительно хотите удалить этикетку "${props.label.labelTemplateName}"? Изменения не обратимы!`,
    onOk: async () => {
      await labelTemplateStore.deletePersonalLabelTemplateById(
        props.label.label.id,
      );
    },
  });
};
</script>

<style scoped lang="scss">
.icon-button {
  padding: 0;
  font-size: 20px;
  line-height: 1;
  background: none;
  border: none;
  box-shadow: none;
}
</style>
